@if (info) {
  <div class="blog-block">
    <div class="category-list">
      @if (info.blogType) {
        <mat-chip-listbox>
          <mat-chip-option color="primary" selected>{{info.blogType.name}}</mat-chip-option>
        </mat-chip-listbox>
      }
      @if (info.dateFrom  || info.dateTo ) {
        <mat-chip-listbox>
          <mat-chip-option>{{info.dateFrom ? info.dateFrom : '-'}}</mat-chip-option> -
          <mat-chip-option>{{info.dateTo ? info.dateTo : '-'}}</mat-chip-option>
        </mat-chip-listbox>
      }
    </div>
    @if (info.image) {
      <img src="{{info?.image}}" class="image">
    }
    @if (videoUrl) {
      <div >
        <iframe [src]="videoUrl" class="video">
        </iframe>
      </div>
    }
    <div class="header-three">
      <div class="part-1" [style.backgroundColor]="opacityColor">
        {{info?.header}}
      </div>
      <div class="part-2">
      </div>
      <div class="part-3">
      </div>
    </div>
    <div class="text-info">
      <div class="title">
        {{info?.title}}
      </div>
      @if (info.text) {
        <div class="text" [innerHTML]="info.text">
        </div>
      }
      @if (info.link) {
        <div class="link">
          <a href="{{info.link | linkHttp}}" target="_blank">{{info.linkLabel}}</a>
        </div>
      }
    </div>
  </div>
}
